angular.module("ainapp")
    .controller("TableDesignController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$timeout",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $timeout) {

            $scope.PageName = "Table Design";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            $scope.load = false;
            $scope.verticalTable = false;
            $scope.columnWidths = {};
            $scope.actualColumnWidths = {};
            $scope.columnList = [];
            $scope.columnIndexByKey = {};
            $scope.applyingWidths = false; // Flag to prevent multiple simultaneous width applications
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }




            $scope.tableReorderColumnArray = [];
            $scope.ReArrangeTable = function () {
                $scope.RearrangeReqired = false;
                $scope.tableReorderColumnArray = [];
                if ($scope.TableReorder != null && $scope.TableReorder != "") {
                    if (
                        $scope.TableReorder.ColumnArray != null &&
                        $scope.TableReorder.ColumnArray != "" &&
                        $scope.TableReorder.ColumnArray != undefined
                    ) {
                        var arr = $scope.TableReorder.ColumnArray;
                        $scope.tableReorderColumnArray = JSON.parse(arr);
                        $scope.RearrangeReqired = true;
                        $scope.rearrangeTableCells($scope.tableReorderColumnArray);
                    }
                }
                if ($scope.ColumnWidth != null) {
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        let key = cell.getAttribute('data-key');
                        if ($scope.ColumnWidth[key] !== undefined) {
                            cell.style.width = $scope.ColumnWidth[key] + "px";
                        }
                    });
                } else {
                    toastr.info("Table Width Adjustment Empty, Applying Default Width")
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        cell.style.width = "100px";
                    });
                }
            };


            $scope.updateVerticalColumnList = function () {
                try {
                    var $table = $("#rearrangeTable");
                    var $theadRow = $table.find('thead tr').first();

                    if (!$theadRow.length) {
                        console.log('Table header not found, skipping vertical list update');
                        return;
                    }

                    var list = [];
                    $scope.columnIndexByKey = {};
                    $theadRow.children('th').each(function (i) {
                        var $th = $(this);
                        if ($th.is(':visible')) {
                            var key = $th.attr('data-key') || String(i);
                            var label = $.trim($th.text()) || key;
                            list.push({ key: key, label: label, index: i });
                            $scope.columnIndexByKey[key] = i;

                            // Only set width if not already set (preserve saved widths)
                            if (!$scope.columnWidths[key]) {
                                var measuredWidth = Math.round($th.outerWidth());
                                $scope.columnWidths[key] = measuredWidth;
                                console.log('updateVerticalColumnList: Set columnWidths for', key, ':', measuredWidth);
                            } else {
                                console.log('updateVerticalColumnList: Preserved existing columnWidths for', key, ':', $scope.columnWidths[key]);
                            }
                            if (!$scope.actualColumnWidths[key]) {
                                var measuredActualWidth = Math.round($th.outerWidth());
                                $scope.actualColumnWidths[key] = measuredActualWidth;
                                console.log('updateVerticalColumnList: Set actualColumnWidths for', key, ':', measuredActualWidth);
                            } else {
                                console.log('updateVerticalColumnList: Preserved existing actualColumnWidths for', key, ':', $scope.actualColumnWidths[key]);
                            }
                        }
                    });
                    $scope.columnList = list;
                    console.log('Updated vertical column list with', list.length, 'columns');
                    $scope.columnWidths2 = angular.copy($scope.columnWidths)
                    $scope.$applyAsync();
                } catch (e) {
                    console.error('Error updating vertical column list:', e);
                }
            };

            $scope.Init = function () {

                $scope.ViewVal = 1;
                $scope.ViewVal2 = 0;
                $scope.VoucherName = $stateParams.VoucherType;
                $scope.ViewValType = $stateParams.VoucherType;
                $scope.selectedVoucher = $stateParams.VoucherType;


                $scope.VoucherType = 'SalesPurchase';
                if ($scope.selectedVoucher == "Cash Payment" || $scope.selectedVoucher == "Cash Receipt" || $scope.selectedVoucher == "Fund Payment" ||
                    $scope.selectedVoucher == "Fund Receipt" || $scope.selectedVoucher == "Cheque Payment" || $scope.selectedVoucher == "Cheque Receipt"
                ) {
                    $scope.VoucherType = 'PayRec';
                    if ($scope.selectedVoucher == "Cheque Payment" || $scope.selectedVoucher == "Cheque Receipt") {
                        $scope.VoucherType = 'PayRecCheque';
                    }
                }
                if ($scope.selectedVoucher == "Opening Balance") {
                    $scope.VoucherType = 'OpBal';
                }
                if ($scope.selectedVoucher == "Journal Voucher" || $scope.selectedVoucher == 'Debit Note' || $scope.selectedVoucher == 'Credit Note') {
                    $scope.VoucherType = 'JV';
                }
                if ($scope.selectedVoucher == "Company Expense") {
                    $scope.VoucherType = 'Company Expense';
                }

                if ($scope.selectedVoucher == "Opening Stock") {
                    $scope.VoucherType = 'Opening Stock';
                }

                if ($scope.selectedVoucher == "Stock Receive" || $scope.selectedVoucher == "Stock Issue" || $scope.selectedVoucher == "Stock FOC") {
                    $scope.VoucherType = 'StockIssRec';
                }
                if ($scope.selectedVoucher == "Stock FOC") {
                    $scope.VoucherType = 'Stock FOC';
                }

                if ($scope.selectedVoucher == "Stock JV") {
                    $scope.VoucherType = 'Stock JV';
                }

                // Column width binding map and vertical row-list mode
                $scope.columnWidths = {};
                $scope.columnWidths2 = {};

                $.LoadingOverlay("show", {
                    image: "images/load.gif"
                });
                $scope.VoucherSettings = {};
                $scope.TableDesign = {};
                $scope.ColumnWidth = null;


                MainService.VoucherSettingsbyType($scope.selectedVoucher).then(
                    function (response) {
                        if (response.data) {
                            $scope.VoucherSettings = response.data;

                            $scope.CompanyProfile = response.data.CompanyProfile;
                            $scope.VDesign = response.data.VoucherDesign;
                            $scope.TableReorder = response.data.TableReorder;
                            $scope.VoucherSet = response.data.voucherAccount;
                            $scope.CostCenters = response.data.CostCenterSettings;


                            MainService.TableDesignsbyVoucher($scope.selectedVoucher).then(function (response2) {
                                if (response2.data != null && response2.data != "") {
                                    $scope.TableDesign = response2.data;
                                    $scope.ColumnWidth = JSON.parse(response2.data.ColumnWidth);

                                    setTimeout(function () {
                                        $scope.ReArrangeTable();
                                        $scope.updateVerticalColumnList();
                                    }, 2000);
                                } else {
                                    $scope.ReArrangeTable();
                                    $scope.updateVerticalColumnList();
                                }
                            });


                        }
                        $.LoadingOverlay("hide");
                    },
                    function (err) {
                        toastr.error("NetworkError");
                        $.LoadingOverlay("hide");
                    }
                );


            }
            $scope.Init();

            $scope.adjusttablewidth = function () {
                if ($scope.columnWidths != null) {
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        let key = cell.getAttribute('data-key');
                        if ($scope.columnWidths[key] !== undefined) {
                            cell.style.width = $scope.columnWidths[key] + "px";
                        }
                    });
                }
            }

            $scope.goToPage = function (data) {
                $state.go("TableDesign", { VoucherType: data })
            }




            $scope.copy = function (data) {
                $scope.copyelement = angular.copy(data);
            }

            $scope.paste = function (data) {
                var name = data.Name;
                var id = null;
                if (data.Settings != null && data.Settings != undefined) {
                    id = data.Settings.Id;
                }
                data.Settings = angular.copy($scope.copyelement.Settings);
                data.Settings.VoucherType = name;
                data.Settings.Id = id;
            }


            $scope.save = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                var voucherType = $scope.ViewValType;

                // Ensure we have valid column widths before saving
                if (!$scope.columnWidths || Object.keys($scope.columnWidths).length === 0) {
                    console.warn('No column widths to save');
                    toastr.warning('No column widths to save');
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                    return;
                }

                // Build save object with current requested widths
                var saveObject = {
                    VoucherType: voucherType,
                    ColumnWidth: JSON.stringify(angular.copy($scope.columnWidths))
                };

                // Log widths as JSON string for debugging/verification
                try {
                    console.log("ColumnWidths payload:", JSON.stringify(saveObject));
                } catch (e) {
                    console.log("ColumnWidths payload (object):", saveObject);
                }

                MainService.AddTableDesign(saveObject).then(function (response) {
                    if (response.data != null) {
                        toastr.success("Success");
                        $scope.Init();
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }





        }]);
